


























import { NavigationMixin } from '@/mixins/navigationMixin'

export default NavigationMixin.extend({
  name: 'BottomNavigation'
})
